import IconComponent from "icons/IconComponent";

import EditCircle from "./EditCircle.svg";

export default (EditCircle as any) as IconComponent;
